import "./TableRepeater.css";

import { ReactNode } from "react";

interface ReadonlyTableRepeaterProps {
  tableHeaders: string[];
  children: ReactNode;
  label?: string;
}

export const ReadonlyTableRepeater = ({ tableHeaders, children, label }: ReadonlyTableRepeaterProps): JSX.Element => {
  return (
    <div className="TableRepeaterContainer TableRepeaterContainer-readonly">
      {label ? (
        <div className="LabelValue LabelValue-right TableRepeaterReadonlyLabel">
          <b>{label}</b>
        </div>
      ) : null}
      <div className="TableRepeaterWrapper">
        <table className="TableRepeater">
          <thead>
            <tr className="TableRepeaterRow">
              {tableHeaders.map((tableHeader) => (
                <th key={tableHeader}>{tableHeader}</th>
              ))}
            </tr>
          </thead>
          <tbody>{children}</tbody>
        </table>
      </div>
    </div>
  );
};
